import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '../../lib/api';
import { useAuth } from '../../contexts/AuthContext';

export interface TakeoffRow {
  id: string;
  category: string;
  material: string;
  quantity: string;
  unit: string;
  notes: string;
}
export interface SavedTakeoff { rows: TakeoffRow[]; revision: number; updated_at: string }
export function useMaterialTakeoff(measurementId: number | undefined, material: string) {
  const { user } = useAuth();
  const client = useQueryClient();
  const key = ['material-takeoff', user?.id, user?.organization?.id, measurementId, material];
  const url = `/api/material-takeoffs/${measurementId}/${material}/`;
  const query = useQuery({
    queryKey: key,
    enabled: !!measurementId,
    queryFn: async () => {
      const response = await api.get<SavedTakeoff>(url);
      return response.data.revision > 0 ? response.data : null;
    },
  });
  const save = useMutation({
    mutationFn: async (input: { rows: TakeoffRow[]; revision: number }) =>
      (await api.put<SavedTakeoff>(url, input)).data,
    onSuccess: (data) => client.setQueryData(key, data),
  });
  return { ...query, save };
}
